import calls from '@/backend/api-calls'

const state = () => ({
  location: null,
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true,
  pagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
  ids: state => {
    return state.location.items.map(d => d.id);
  }
}

// actions
const actions = {
  getLocation: ({commit}, locationId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.warehouseLocation.get(locationId)
        .then(resp => {
          commit("setLocation", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  moveStorageUnit: ({commit, dispatch}, { locationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.storages.transfer(data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse item successfully moved'
          }, { root: true });
          dispatch("getLocation", locationId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  changeStorageLocation: ({commit, dispatch}, { locationId, storageId, data }) => {
    return new Promise((resolve, reject) => {
      calls.storage.put(storageId, data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage space successfully re-assigned'
          }, { root: true });
          dispatch("getLocation", locationId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setLocation(state, data) {
    state.location = data;
  },
  removeItem(state, itemId) {
    state.location.items.forEach((item, i) => {
      if (item.id == itemId) {
        state.location.items.splice(i, 1);
      }
      const index = state.selected.indexOf(itemId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  adjustItemQuantity(state, { itemId, qty }) {
    state.location.items.forEach(item => {
      if (item.id == itemId) {
        item.qty = qty
      }
    })
  }, 
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}